import store from "../../store";
/*import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../helpers/PGSHelper.js';*/

export default class GruposClientes {
  static typeSearch = "local"; //online || local
  static rules = {
    Nombres: [(value) => !!value || "El grupo de cliente es obligatorio"],
  };

  constructor(data = null) {
    this.Nombre = data?.Nombre ? data.Nombre : "";
    this.Tenant = data?.Tenant
      ? data.Tenant
      : store.getters.getFirebaseApp.tenant;
    this.Id = data?.Id ? data.Id : null;
  }

  static getRules() {
    return this.rules;
  }

  static getPropertyModel() {
    return this;
  }
}
